import React, { useEffect, useState } from "react";
import "./VitalData.scss";
import { ProgressBarCustom } from "../ProgressBarCustom/ProgressBarCustom";
import ChartCustom from "../Chart/Chart";
import ApexChart from "../../components/Chart/ApexChart";

export function VitalData(props) {
    const TIME_RANGE_IN_MILLISECONDS = 50 * 1000;

    const [barPercen, setBarPercen] = useState(0);
    const [dataObj, setDataObj] = useState(() => {
        return {
            pressureDataList: [],
            volumeDataList: [],
            flowDataList: []
        }
    });

    useEffect(() => {
        console.log(props.data);
    }, [])

    useEffect(() => {
        const interval = setInterval(() => {
            setDataObj((prevDataObj) => {
                let pDataList = prevDataObj.pressureDataList;
                let vDataList = prevDataObj.volumeDataList;
                let fDataList = prevDataObj.flowDataList;

                // console.log("count :: " + count);
                // pGraph.map( (graphData) => {
                pDataList.push({ x: new Date(), y: Math.floor(Math.random() * 80) })
                // });
                // vGraph.map( (graphData) => {
                vDataList.push({ x: new Date(), y: Math.floor(Math.random() * 50) })
                //    });
                // fGraph.map( (graphData) => {
                fDataList.push({ x: new Date(), y: Math.floor(Math.random() * 70) })
                // });

                // pDataList.push({x: pGraph.time, y: pGraph.value });
                // vDataList.push({x: vGraph.time, y: vGraph.value });
                // fDataList.push({x: fGraph.time, y: fGraph.value });

                if (pDataList.length > 500) pDataList.splice(0, 30);
                if (vDataList.length > 500) vDataList.splice(0, 30);
                if (fDataList.length > 500) fDataList.splice(0, 30);


                // console.log("pressureDataList: " + JSON.stringify(pDataList));
                return {
                    ...prevDataObj,
                    pressureDataList: pDataList,
                    volumeDataList: vDataList,
                    flowDataList: fDataList
                }
            })
        }, 1000)

        return () => clearInterval(interval);
    }, [dataObj])

    return (
        <div className="graph-data">
            {/* {console.log('vital data rerendering!!')} */}
            <div className="graph-container">
                {/* <ChartCustom /> */}
                <div className="ecg-graph-1">
                    <ApexChart className="chart"
                        dataList={dataObj.pressureDataList}
                        range={TIME_RANGE_IN_MILLISECONDS}
                        yMin={0}
                        yMax={80}
                        yTickPoint={4}
                        width={"100%"}
                        height={"100%"}
                        lineColor={'#299842'}
                        yTitle={['Pressure', '(cmH20)']}
                        yColor={'#20BBC1'}
                        name='apex-ecg-1'
                    />
                </div>
                <div className="ecg-graph-2">
                    <ApexChart className="chart"
                        dataList={dataObj.volumeDataList}
                        range={TIME_RANGE_IN_MILLISECONDS}
                        yMin={0}
                        yMax={80}
                        yTickPoint={4}
                        width={"100%"}
                        height={"100%"}
                        lineColor={'#299842'}
                        yTitle={['Pressure', '(cmH20)']}
                        yColor={'#20BBC1'}
                        name='apex-ecg-2'
                    />
                </div>
                <div className="pleth-graph">
                    <ApexChart className="chart"
                        dataList={dataObj.flowDataList}
                        range={TIME_RANGE_IN_MILLISECONDS}
                        yMin={0}
                        yMax={80}
                        yTickPoint={4}
                        width={"100%"}
                        height={"100%"}
                        lineColor={'#47F4FF'}
                        yTitle={['Pressure', '(cmH20)']}
                        yColor={'#20BBC1'}
                        name='apex-pleth-graph'
                    />
                </div>
                <div className="resp-graph">
                    <ApexChart className="chart"
                        dataList={dataObj.flowDataList}
                        range={TIME_RANGE_IN_MILLISECONDS}
                        yMin={0}
                        yMax={80}
                        yTickPoint={4}
                        width={"100%"}
                        height={"100%"}
                        lineColor={'#FFED47'}
                        yTitle={['Pressure', '(cmH20)']}
                        yColor={'#20BBC1'}
                        name='apex-resp-graph'
                    />
                </div>
            </div>
            <div className="data-container">
                <div className="vital-data ecg">
                    <div className="vital-name-container">
                        <div className="vital-name">
                            ECG
                        </div>
                        <div className="vital-unit">
                            {(props.data.ecg && props.data.ecg.unit) || 'b/min'}
                        </div>
                    </div>
                    <div className="vital-value-container">
                        {(props.data.ecg && props.data.ecg.data && props.data.ecg.data.value) || '76'}
                    </div>
                    <div className="vital-lb-container">
                        <div className="vital-lb-high">
                            {(props.data.ecg && props.data.ecg.conf && props.data.ecg.conf.high) || '160'}
                        </div>
                        <div className="vital-lb-low">
                            {props.data.ecg && props.data.ecg.conf && props.data.ecg.conf.low || '60'}
                        </div>
                    </div>
                </div>
                <div className="vital-data spo2">
                    <div className="vital-name-container">
                        <div className="vital-name">
                            SPO2
                        </div>
                    </div>
                    <div className="vital-value-container">
                        {(props.data.spo2 && props.data.spo2.data && props.data.spo2.data.value) || '98'}
                    </div>
                    <div className="vital-lb-container">
                        <div className="vital-lb-high">
                            {(props.data.spo2 && props.data.spo2.conf && props.data.spo2.conf.high) || '100'}
                        </div>
                        <div className="vital-lb-low">
                            {(props.data.spo2 && props.data.spo2.conf && props.data.spo2.conf.low) || '90'}
                        </div>
                    </div>
                    <div className="vital-rt-container">
                        <div className="rt-vital-name">
                            PI
                        </div>
                        <div className="rt-vital-value">
                            {(props.data.spo2 && props.data.spo2.data && props.data.spo2.data.PI) || '--'}
                        </div>
                    </div>
                    <div className="vital-rb-container">
                        <div className="rb-vital-name">
                            PR
                        </div>
                        <div className="rb-vital-value">
                            {(props.data.spo2 && props.data.spo2.data && props.data.spo2.data.PR) || '--'}
                        </div>
                    </div>
                </div>
                <div className="vital-data resp">
                    <div className="vital-name-container">
                        <div className="vital-name">
                            RESP
                        </div>
                        <div className="vital-unit">
                            {(props.data.resp && props.data.resp.unit) || 'b/min'}
                        </div>
                    </div>
                    <div className="vital-value-container">
                        {(props.data.resp && props.data.resp.data && props.data.resp.data.value) || '61'}
                    </div>
                    <div className="vital-lb-container">
                        <div className="vital-lb-high">
                            {(props.data.resp && props.data.resp.conf && props.data.spo2.resp.high) || '100'}
                        </div>
                        <div className="vital-lb-low">
                            {(props.data.resp && props.data.resp.conf && props.data.resp.conf.low) || '40'}
                        </div>
                    </div>
                    <div className="vital-rb-container">
                        <div className="rb-vital-name source-ecg">
                            {(props.data.resp && props.data.resp.source) || 'SOURCE ECG'}
                        </div>
                    </div>
                </div>
            </div>
            <div className="temp-container">
                <div className="temp-name-container">
                    <div className="temp-name">
                        Temp
                    </div>
                    <div className="temp-name">
                        &#x2103;
                    </div>
                </div>
                <div className="temp-hl-container">
                    <div className="temp-high">
                        {(props.data.temp && props.data.temp.conf && props.data.temp.conf.high) || '120'}
                    </div>
                    <div className="temp-low">
                        {(props.data.temp && props.data.temp.conf && props.data.temp.conf.low) || '70'}
                    </div>
                </div>
                <div className="temp-t1-container">
                    <div className="temp-name">
                        {`T1 X5`}
                    </div>
                    <div className="temp-value">
                        {(props.data.temp && props.data.temp.data && props.data.temp.data.T1_X5) || '32.4'}
                    </div>
                </div>
                <div className="temp-t2-container">
                    <div className="temp-name">
                        {`T2 X6`}
                    </div>
                    <div className="temp-value">
                        {(props.data.temp && props.data.temp.data && props.data.temp.data.T1_X6) || '33.4'}
                    </div>
                </div>
                <div className="temp-td-container">
                    <div className="td-name">
                        {`TD`}
                    </div>
                    <div className="td-value">
                        {(props.data.temp && props.data.temp.data && props.data.temp.data.TD) || '34.4'}
                    </div>
                </div>
            </div>
            <div className="bp-container">
                <div className="progress-bar-container">
                    <div className="nibp-name-container">
                        <div className="nibp-name">
                            NIBP
                        </div>
                        <div className="nibp-unit">
                            {props.data.nibp && props.data.nibp.unit}
                        </div>
                    </div>
                    <div className="progress-bar">
                        <ProgressBarCustom
                            completed={80}
                            isLabelVisible={true}
                            labelLeft={'@18.35'}
                            labelRight={'15 min'}
                        />
                    </div>
                </div>
                <div className="nibp-data-container">
                    <div className="nibp-hl-container">
                        <div className="high-nibp">
                            {(props.data.nibp && props.data.nibp.conf && props.data.nibp.conf.high) || '120'}
                        </div>
                        <div className="low-nibp">
                            {(props.data.nibp && props.data.nibp.conf && props.data.nibp.conf.low) || '70'}
                        </div>
                    </div>
                    <div className="nibp-data">
                        {(props.data.nibp && props.data.nibp.data && props.data.nibp.data.high) || '112'}/{(props.data.nibp && props.data.nibp.data && props.data.nibp.data.low) || '88'}
                    </div>
                    <div className="nibp-avg-data">
                        ({(props.data.nibp && props.data.nibp.data && props.data.nibp.data.avg) || '93'})
                    </div>
                </div>
            </div>
        </div>
    );
}